import React from 'react';
import { useTranslation } from 'react-i18next';

export default function NewRelease() {
  const { t } = useTranslation();
  return (
    <div className="nrp-wrapper">
      <div className="label">{t('cms.dashboard.strategy.module_setting.newRelease')}</div>
      <div className="right-wrapper">{t('cms.dashboard.strategy.homepage_setting.tips')}</div>
    </div>
  );
}
